export default __webpack_public_path__ + "static/media/autonomy.2b3194ec.svg";